import React, { useEffect, useState } from "react";
import { t } from "i18next";
import { PlusIcon, MinusIcon } from "icons";
import { Tooltip } from "antd";
const Quantity = ({ singleItem, decreaseQuantity, increaseQuantity }) => {
  return (
    <div className="py-6">
      <p className="font-semibold px-4 text-16x">{t("Quantity")}</p>
      <div className=" car-add-decrrese w-150x my-0 mx-auto">
        <div className="flex justify-between relative items-center mt-6">
          <span className="inline-flex" onClick={decreaseQuantity}>
            <button className="cursor-pointer">
              <div className="text-theme-green">
                <span className="w-6 h-6">
                  <MinusIcon />
                </span>
              </div>
            </button>
          </span>
          <span className="inline-flex justify-center text-center mx-1">
            <span className="">
              <span className="text-32x font-bold text-black">
                {singleItem?.quantity}
              </span>
            </span>
          </span>

          <span className="inline-flex" onClick={increaseQuantity}>
            <button className="cursor-pointer">
              <div className="text-theme-green">
                <span className="w-6 h-6">
                  <PlusIcon />
                </span>
              </div>
            </button>
          </span>
        </div>
      </div>
    </div>
  );
};

export const QuantitySelector = ({
  // Core Behavior Props
  min = 1,
  max = 99,
  value = 1,
  onChange = () => {},
  decreaseQuantity,
  increaseQuantity,
  disable = false,
  // Blocks only the + button. `disable` freezes the whole control, so callers
  // that pass a stock cap through it leave the customer unable to reduce or
  // remove an item once it reaches the maximum available quantity.
  disableIncrease = false,
  disableMessage = "Quantity selection is disabled",
  showDisableMessage = true,
  // Style Groups
  wrapperStyleProps = { className: "", style: {} },
  buttonStyleProps = { className: "", style: {} },
  quantityStyleProps = { className: "", style: {} },
}) => {
  const [quantity, setQuantity] = useState(value);

  const handleDecrease = (e) => {
    e.stopPropagation();
    if (disable) return;
    if (decreaseQuantity) {
      decreaseQuantity();
      return;
    }
    if (quantity > min) {
      const newQty = quantity - 1;
      setQuantity(newQty);
      onChange(newQty);
    }
  };

  const handleIncrease = (e) => {
    e.stopPropagation();
    if (disable || disableIncrease) return;
    if (increaseQuantity) {
      increaseQuantity();
      return;
    }
    if (quantity < max) {
      const newQty = quantity + 1;
      setQuantity(newQty);
      onChange(newQty);
    }
  };

  useEffect(() => {
    setQuantity(value);
  }, [value]);

  return (
    <div
      className={`relative flex items-center rounded-16x p-3 w-fit ${
        disable ? "bg-gray-200 cursor-not-allowed opacity-50" : "bg-gray-200"
      } ${wrapperStyleProps.className}`}
      style={wrapperStyleProps.style}
    >
      {/* Decrease Button */}
      <div className="relative flex items-center justify-center w-6 h-6">
        <button
          className={`absolute inset-0 text-15x text-gray-700 font-bold focus:outline-none disabled:cursor-not-allowed transition-transform duration-300 hover:scale-125 hover:text-17x ${buttonStyleProps.className}`}
          style={buttonStyleProps.style}
          onClick={handleDecrease}
          disabled={disable}
        >
          –
        </button>
      </div>

      {/* Quantity Display */}
      <span
        className={`mx-3 text-15x text-gray-900 font-medium select-none ${quantityStyleProps.className}`}
        style={quantityStyleProps.style}
      >
        {quantity}
      </span>

      {/* Increase Button */}
      <div className="relative flex items-center justify-center w-6 h-6">
        <button
          className={`absolute inset-0 text-15x text-brand-base-primary font-bold focus:outline-none disabled:cursor-not-allowed transition-transform duration-300 hover:scale-125 hover:text-17x ${buttonStyleProps.className}`}
          style={buttonStyleProps.style}
          onClick={handleIncrease}
          disabled={disable || disableIncrease}
        >
          +
        </button>
      </div>

      {/* Tooltip */}
      {(disable || disableIncrease) && showDisableMessage && disableMessage && (
        <div className="ml-3 relative flex items-center">
          <Tooltip title={disableMessage}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="w-4 h-4 text-gray-100 cursor-pointer"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 8h.01M12 12v4m0 8a10 10 0 100-20 10 10 0 000 20z"
              />
            </svg>
          </Tooltip>
        </div>
      )}
    </div>
  );
};


export default Quantity;
